import { render, staticRenderFns } from "./fulfillmentOrder.vue?vue&type=template&id=73013eb4&scoped=true"
import script from "./fulfillmentOrder.vue?vue&type=script&lang=js"
export * from "./fulfillmentOrder.vue?vue&type=script&lang=js"
import style0 from "./fulfillmentOrder.vue?vue&type=style&index=0&id=73013eb4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73013eb4",
  null
  
)

export default component.exports